import classNames from 'classnames';
import Divider from '@mui/material/Divider';
import PropTypes from 'prop-types';
import React from 'react';

import QButton from 'components/QButton';

import useStyles from './styles';

const MultiSelectBottomButtons = React.forwardRef((props, ref) => {
  const {
    children,
    cancelFocus,
    cancelFilter,
    mySelectedItems,
    applyFilter,
    sticky = true,
    className,
    ...otherProps
  } = props;
  const { classes } = useStyles();

  return (
    <div
      {...otherProps}
      ref={ref}
      className={classNames(sticky ? classes.stickyButtonWrapper : classes.buttonWrapper, className)}
    >
      {children}
      <div className={classes.innerButtonDiv}>
        <Divider className={classes.lastDivider} />
        <div className={classes.flexRow}>
          <QButton
            ref={cancelFocus}
            tabIndex={0}
            variant='outlined'
            className={classes.cancelButton}
            onClick={cancelFilter}
            id='cancel_filter_button'
          >
            Cancel
          </QButton>
          <QButton
            tabIndex={0}
            variant='contained'
            disabled={Boolean(!mySelectedItems?.length)}
            className={classes.applyButton}
            onClick={applyFilter}
            id='apply_filter_button'
          >
            Apply
          </QButton>
        </div>
      </div>
    </div>
  );
});

MultiSelectBottomButtons.propTypes = {
  applyFilter: PropTypes.func,
  cancelFilter: PropTypes.func,
  cancelFocus: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({ current: PropTypes.any })]),
  children: PropTypes.any,
  className: PropTypes.string,
  mySelectedItems: PropTypes.array,
  sticky: PropTypes.bool,
};

MultiSelectBottomButtons.displayName = 'MultiSelectBottomButtons';

export default MultiSelectBottomButtons;
